import { Paragraph } from '@uncinc/react-drupal-core';
import type { ParagraphEntity, ReferenceField } from '@uncinc/react-drupal-core/types';
import classNames from 'classnames';
import Immutable from 'immutable';
import React, { useMemo } from 'react';

declare interface ParagraphsRenderProps extends Record<string, any> {
  paragraphs: ReferenceField<ParagraphEntity>[];
  className?: string;
}

interface ParagraphsExclude extends ParagraphsRenderProps {
  exclude?: string[];
  only?: never;
}
interface ParagraphsOnly extends ParagraphsRenderProps {
  exclude?: never;
  only?: string[];
}

const ParagraphsRenderer: React.FC<ParagraphsExclude | ParagraphsOnly> = ({
  paragraphs,
  className,
  exclude = [],
  only = [],
  ...restProps
}) => {
  const paragraphsFiltered = useMemo(() => {
    const isImmutable = Immutable.isImmutable(paragraphs);
    const paragraphsArray = isImmutable
      ? (paragraphs.toJS() as ReferenceField<ParagraphEntity>[])
      : paragraphs;

    return paragraphsArray.filter((paragraph) => {
      if (only.length) {
        return only.includes(paragraph.entity?.type[0].target_id);
      }

      if (exclude.length) {
        return !exclude.includes(paragraph.entity?.type[0].target_id);
      }

      return true;
    });
  }, [exclude, only, paragraphs]);

  if (!paragraphsFiltered.length) return null;

  const classes = classNames('Paragraphs', className);

  return (
    <div className={classes}>
      {paragraphsFiltered
        .map((paragraph) => {
          const id = paragraph.target_id;
          const language = paragraph.entity?.langcode[0]?.value;

          return (
            <Paragraph
              {...restProps}
              key={`paragraph:${id}:${language}`}
              id={id}
              entity={Immutable.fromJS(paragraph.entity)}
            />
          );
        })}
    </div>
  );
};

export default ParagraphsRenderer;
